import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=28b5ac43&scoped=true&"
import script from "./Policy.vue?vue&type=script&lang=js&"
export * from "./Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b5ac43",
  null
  
)

export default component.exports